import { Modal } from './Modal';
import { EDITOR_KEY_GROUPS } from '../pages/create/editorKeys';
import { SUBTITLE_KEY_GROUP } from '../subtitles/keys';

const GROUPS: Array<[string, Array<[string, string[]]>]> = [
  ['Everywhere', [['Search the library', ['/']], ['Upload files', ['U']], ['Show shortcuts', ['?']]]],
  ['Library', [
    ['Move selection', ['←', '→', '↑', '↓']], ['Extend selection', ['Shift', '←/→/↑/↓']], ['Add or remove one', ['⌘/Ctrl', 'Click']], ['Select a range', ['Shift', 'Click']],
    ['Select everything loaded', ['⌘/Ctrl', 'A']], ['Open asset', ['Enter']], ['Grid / table view', ['G']],
    ['Clear the selection, then search and filters', ['Esc']],
  ]],
  ['Player', [
    ['Play / pause', ['Space']], ['Shuttle back / stop / forward', ['J', 'K', 'L']], ['Step one frame', ['←', '→']], ['Previous / next shot', ['↑', '↓']],
    ['Jump one second', ['Shift', '←/→']], ['Mark in / out', ['I', 'O']], ['Go to in / out', ['Shift', 'I/O']],
    ['Clear in and out', ['Alt', 'X']], ['Mute', ['M']], ['Fullscreen', ['F']],
  ]],
  // 1.7.4: the sequence editor's main keys (the editor's Keys tab lists them all).
  ['Editor', EDITOR_KEY_GROUPS.filter((g) => g !== SUBTITLE_KEY_GROUP).flatMap((g) => g.rows.filter((r) => r.main).map((r): [string, string[]] => [r.label, r.keys]))],
  // 1.9.0: the subtitle keys, in the asset Subtitles tab and the editor's Subtitles tab.
  ['Subtitles', SUBTITLE_KEY_GROUP.rows.map((r): [string, string[]] => [r.label, r.keys])],
];

/** A line under a group, for settings that go with its keys. */
const NOTES: Record<string, string> = {
  Editor: 'In the sequence editor; its Keys tab lists every editor shortcut.',
  Subtitles: 'While the Subtitles tab is open, on an asset or in the sequence editor. In the editor ⌥, and ⌥. nudge a cue only when one is selected; otherwise they slip the selected clip.',
  Player: 'Show shots, in the player’s controls, shows or hides the shot ticks on the timeline (remembered for you). Assets without detected shots have no ticks and no ↑ / ↓ jumps.',
};

export function ShortcutsHelp({ onClose }: { onClose: () => void }) {
  return (
    <Modal title="Keyboard shortcuts" onClose={onClose} actions={<button className="btn" onClick={onClose}>Close</button>}>
      {GROUPS.map(([group, rows]) => (
        <div key={group}>
          <p className="section-label">{group}</p>
          <div className="shortcut-grid">
            {rows.map(([label, keys]) => (
              <div key={label} style={{ display: 'contents' }}>
                <span>{label}</span>
                <span className="keys">{keys.map((k) => <kbd key={k}>{k}</kbd>)}</span>
              </div>
            ))}
          </div>
          {NOTES[group] && <p className="faint" style={{ fontSize: 12, marginTop: 6 }} data-testid={`shortcuts-note-${group.toLowerCase()}`}>{NOTES[group]}</p>}
        </div>
      ))}
    </Modal>
  );
}
